import styled from 'styled-components'
import { FlexipageColors, headingSizes } from "../../Flexipage/Global/FlexipageStyles";

export const CaseStudyCtaWrapper = styled.section`
	padding-block: 6rem;
	background: linear-gradient(180deg, rgba(116, 151, 237, 0.30) 0%, rgba(85, 186, 164, 0.30) 100%);
	font-family: Poppins, sans-serif;

	h2 {
		text-align: center;
		color: ${FlexipageColors.blue1000};
		margin: 0 0 4rem;
		text-wrap: balance;

		font-size: ${headingSizes.h4.desktop[0]};
		line-height: ${headingSizes.h4.desktop[1]};
		font-family: ${headingSizes.h4.fontFamily};
		font-weight: ${headingSizes.h4.fontWeight};

		@media (max-width: ${FlexipageColors.breakpointTablet}) {
			font-size: ${headingSizes.h4.tablet[0]};
			line-height: ${headingSizes.h4.tablet[1]};
		}

		@media (max-width: ${FlexipageColors.breakpointMobile}) {
			font-size: ${headingSizes.h4.mobile[0]};
			line-height: ${headingSizes.h4.mobile[1]};
		}
	}

	.buttons {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: center;
		gap: 2rem;

		> * {
			flex-shrink: 0;
		}
	}

	.btn {
		display: inline-flex;
		align-items: center;
		gap: 0.5rem;
		background: ${FlexipageColors.teal1000};
		color: white;
		font-weight: 500;
		border-radius: 0.5rem;
		padding: 0.625rem 0.825rem;
		font-size: 1rem;
		line-height: 1.2;

		&:hover,
		&:focus-visible {
			background-color: ${FlexipageColors.teal1200};
		}

		&:focus {
			box-shadow: none;
		}

		&:focus-visible {
			outline: 2px solid ${FlexipageColors.blue1000};
			outline-offset: 2px;
		}

		&.ghost {
			background: transparent !important;
			color: ${FlexipageColors.blue1000};

			&:hover {
				text-decoration: underline;
			}
		}

		svg {
			height: 1rem;
			color: inherit;
			flex-shrink: 0;
		}
	}

	@media screen and (max-width: 767px) {
		padding-block: 4rem;

		h2 {
			margin-bottom: 3rem;
		}

		.buttons {
			gap: 1rem;
		}
	}
`